import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildPoolTicketsRequest = ({
  poolId,
  projectId,
  query = '',
}: {
  poolId: string;
  projectId: string;
  query?: string;
}): TicketManagerApiRequest => {
  const searchParams = new URLSearchParams(query);

  searchParams.set('ticket_pool_id', poolId);

  const queryString = searchParams.toString();

  return {
    method: HttpMethod.GET,
    url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets${queryString ? `?${queryString}` : ''}`,
  };
};

export const buildQueueTicketsRequest = ({
  projectId,
  query = '',
  queueId,
}: {
  projectId: string;
  query?: string;
  queueId: string;
}): TicketManagerApiRequest => {
  const queryString = new URLSearchParams(query).toString();

  return {
    method: HttpMethod.GET,
    url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/queues/${queueId}/tickets${
      queryString ? `?${queryString}` : ''
    }`,
  };
};
